var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.config ? { '--global-background-color': _vm.config.background_color, '--icon-color': _vm.config.font_color  } : {}),attrs:{"id":"app"}},[_c('Window'),_c('link',{attrs:{"rel":"stylesheet","href":"https://unpkg.com/vue-tel-input/dist/vue-tel-input.css"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }